module.exports = "<div class=form-group> <div class=form-label> <div class=form-label__txt>{{title}}</div> <div class=\"js-help-text-region form-label__info\"></div> <div class=\"js-error-text-region form-label__error\"></div> </div> <div class=\"form-editor js-editor-region\"></div> </div>";


//////////////////
// WEBPACK FOOTER
// ../src/form/fields/templates/field.hbs
// module id = 698
// module chunks = 0